<template>
  <div>
    <common-list
      ref="list"
      url="RegisterQueue/GetList"
      @currentrow="handlerCurrentRow"
      label-position="left"
      label-width="100px"
      :SerchShow="true"
      :init="filter"
      tableHeight="calc(100vh - 320px)"
    >
      <!-- 检索条件区域 -->
      <template v-slot:filter="{ filter }">
        <el-col :span="6">
          <el-form-item label="入场编号">
            <el-input
              v-model="filter.RegistrationNum"
              placeholder="入场编号"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车牌号">
            <el-input
              v-model="filter.LicensePlate"
              placeholder="车牌号"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12" class="date">
          <el-form-item>
            <template slot="label">
              <el-select
                v-model="filter.DateType"
                :popper-append-to-body="true"
                class="select_down"
                ref="select"
                @change="changeDateType($event)"
                popper-class="step-one-DateType"
                filterable
                default-first-option
                placeholder="下单日期"
                @keyup.enter.native="query"
              >
                <el-option
                  v-for="item in queryOptions.DateType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
            <el-date-picker
              v-model="filter.TypeSelectedDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车辆状态">
            <RemoteSelect
              v-model="filter.QueueStatus"
              url="DataDic/GetItemsByType?dicType=QueueStatus"
              code="DicCode"
              name="DicName"
            ></RemoteSelect>
          </el-form-item>
        </el-col>
      </template>
      <!-- 按钮区域 -->
      <template v-slot:option>
        <el-button type="warning" icon="el-icon-edit" @click="show"
          >查看</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-plus"
          v-if="auth('registerqueueexport')"
          @click="exp"
          >导出</el-button
        >
      </template>
      <!-- 数据列表区域 -->
      <template v-slot:body>
        <el-table-column
          label="车辆编号"
          prop="CarId"
          show-overflow-tooltip
          width="100"
        ></el-table-column>
        <el-table-column
          label="车牌号"
          prop="LicensePlate"
          show-overflow-tooltip
          width="120"
        ></el-table-column>
        <el-table-column
          label="车架号"
          prop="Vin"
          width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="入场编号/喷漆编号"
          prop="RegistrationNum"
          show-overflow-tooltip
          width="200"
        >
          <template slot-scope="scope"
            >{{
              scope.row.RegistrationNum == 0
                ? "未编号"
                : scope.row.RegistrationNum
            }}
          </template></el-table-column
        >
        <el-table-column
          label="收车员"
          prop="CreateUserId"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{
            scope.row.CreateUserId | gang
          }}</template>
        </el-table-column>
        <el-table-column
          label="收车日期"
          prop="CreateTime"
          show-overflow-tooltip
          width="120"
        >
          <template slot-scope="scope">{{
            scope.row.CreateTime | datetime("YYYY-MM-DD")
          }}</template>
        </el-table-column>
        <el-table-column
          label="查验员"
          prop="InspectorUserId"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{
            scope.row.InspectorUserId | UserNameInfo
          }}</template>
        </el-table-column>
        <el-table-column
          label="查验日期"
          prop="InspectorDate"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{
            scope.row.InspectorDate | datetime("YYYY-MM-DD")
          }}</template>
        </el-table-column>
        <el-table-column label="司磅员" prop="WeighUser" show-overflow-tooltip>
          <template slot-scope="scope">{{
            scope.row.WeighUser | gang
          }}</template>
        </el-table-column>
        <el-table-column
          label="称重日期"
          prop="WeighDate"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{
            scope.row.WeighDate | datetime("YYYY-MM-DD")
          }}</template>
        </el-table-column>
        <el-table-column label="登记员" prop="RegUserId" show-overflow-tooltip>
          <template slot-scope="scope">{{
            scope.row.RegUserId | gang
          }}</template>
        </el-table-column>
        <el-table-column label="登记时间" prop="RegDate" show-overflow-tooltip>
          <template slot-scope="scope">{{
            scope.row.RegDate | datetime("YYYY-MM-DD")
          }}</template>
        </el-table-column>
        <el-table-column label="车辆状态">
          <template slot-scope="{ row }">
            <!-- :color="yellow" -->
            <!-- <el-tag size="medium" effect="plain">
              {{ scope.row.QueueStatus | enumer("register_queue_state") }}
            </el-tag> -->
            <el-tag
              v-if="row.QueueStatus == 1"
              size="medium"
              type=""
              effect="dark"
            >
              {{ row.QueueStatus | enumer("register_queue_state") }}
            </el-tag>
            <el-tag
              v-if="row.QueueStatus == 2"
              size="medium"
              type="success"
              effect="dark"
            >
              {{ row.QueueStatus | enumer("register_queue_state") }}
            </el-tag>
            <el-tag
              v-if="row.QueueStatus == 3"
              size="medium"
              type="danger"
              effect="dark"
            >
              {{ row.QueueStatus | enumer("register_queue_state") }}
            </el-tag>
            <el-tag
              v-if="row.QueueStatus == 4"
              size="medium"
              type="warning"
              effect="dark"
            >
              {{ row.QueueStatus | enumer("register_queue_state") }}
            </el-tag>
            <el-tag
              v-if="row.QueueStatus == 5"
              size="medium"
              type="warning"
              effect="light"
            >
              {{ row.QueueStatus | enumer("register_queue_state") }}
            </el-tag>
            <el-tag
              v-if="row.QueueStatus == 6"
              size="medium"
              type="danger"
              effect="light"
            >
              {{ row.QueueStatus | enumer("register_queue_state") }}
            </el-tag>
            <el-tag
              v-if="row.QueueStatus == 7"
              size="medium"
              type="success"
              effect="light"
            >
              {{ row.QueueStatus | enumer("register_queue_state") }}
            </el-tag>
          </template></el-table-column
        >
      </template>
    </common-list>
    <!-- 弹出框 -->
    <div>
      <div><Showdialog :item="itemShow"></Showdialog></div>
    </div>
  </div>
</template>

<script>
import Showdialog from "./Show";
export default {
  components: { Showdialog },
  data() {
    const now = this.$dayjs(new Date());
    return {
      filter: {
        DateType: "收车日期",
        TypeSelectedDate: [this.$dateformat(now), this.$dateformat(now)],
      },
      itemShow: {},
      // 查询条件备选
      queryOptions: {
        DateType: [
          { label: "收车日期", value: "收车日期" },
          { label: "查验日期", value: "查验日期" },
          { label: "称重日期", value: "称重日期" },
          { label: "登记日期", value: "登记日期" },
        ],
      },
    };
  },

  methods: {
    // 获取当期日期
    changeDateType(event) {
      this.getData();
    },

    getData() {
      this.$refs.list.getTableData();
    },

    show() {
      if (!this.hasCurrentRow()) {
        this.$message.error("请选择查看的内容！");
        return;
      }
      this.itemShow = { KeyId: this.currentrow.CarId };
    },
    //导出excel
    exp() {
      var parm = { ...this.$refs.list.filter };

      if (parm.TypeSelectedDate) {
        parm.TypeSelectedDate = JSON.stringify(parm.TypeSelectedDate);
      }
      this.$download("RegisterQueue/RegisterQueueExport", {
        ...parm,
        FileName: "待拆解队列",
      });
    },
  },
};
</script>

<style>
</style>